<template>
    <modal @close="closeRequestModal">
        <h3>Warehouse Request</h3>
        <div v-if="!response.data" class="large-form">
            
            <div v-if="type=='orders'">
                <div class="form-line" v-if="items.length==1">
                    <div class="form-field" style="width: 25%">
                        <label>Order ID</label>
                        <div class="form-static-field" style="margin-top: -5px"><a href="#" target="_blank">#{{ items[0].warehouse_id }}</a></div>
                    </div>
                    <div class="form-field field-order-status" style="width: 30%">
                        <label>Order Status</label>
                        <div :class="'status status-'+items[0].status">{{ items[0].status }}</div>
                    </div>
                    <div class="form-field" style="width: 40%; margin-left: 5%">
                        <label>Order Date</label>
                        <div style="text-align: left; line-height: 24px">{{ items[0].order_date }}</div>
                    </div>
                </div>
    
                <div class="form-line" v-else>
                    <div class="form-field">
                        <label>Multiple Order Request</label>
                        <div style="text-align: left">Multiple order request for <b>{{ items.length }}</b> orders.</div>
                    </div>
                </div>
            </div>

            <div v-else-if="type=='products'">
                <div class="form-line" v-if="items.length==1">
                    
                    <div class="form-field field-product" style="text-align: left">
                        <label>Product</label>
                        <div>
                            <div class="product-image" :style="items[0].image_url?'background-image:url('+items[0].image_url+')':''"></div>
                            <div class="product-name value"><b>{{ items[0].name }}</b></div>
                            <div class="product-sku"><b>SKU:</b> {{ items[0].sku }}</div>
                        </div>
                    </div>
                </div>

                <div class="form-line" v-else>
                    <div class="form-field">
                        <label>Multiple Products Request</label>
                        <div style="text-align: left">Multiple products request for <b>{{ items.length }}</b> products.</div>
                    </div>
                </div>
            </div>
            
            <div class="form-line">
                <div class="form-field" style="width: 100%">
                    <label>Request Type</label>
                    <select v-model="form.subject" required>
                        <option value="General Query">General Query</option>
                        <option v-if="type=='orders'" value="Change Address">Change Address</option>
                        <option v-if="type=='orders'" value="Change Content">Change Content</option>
                        <option v-if="type=='orders'" value="Specify Carrier & Delivery method">Specify Carrier & Delivery method</option>
                        <option v-if="type=='orders'" value="Specify / Change Delivery Date">Specify / Change Delivery Date</option>
                        <option v-if="type=='orders'" value="Resend (returns only)">Resend (returns only)</option>
                        <option v-if="type=='products'" value="Restock Request">Restock Request</option>
                    </select>
                </div>
            </div>
            <div class="form-line">
                <div class="form-field" style="width: 100%">
                    <label>Request Details</label>
                    <textarea v-model="form.message" required rows="4" placeholder="Please enter details of your request..."></textarea>
                </div>

                <div class="form-field form-field-checkbox" >
                    <div class="checkbox-option">
                        <input v-model="form.urgent" type="checkbox">
                        <span class="checkbox-label">Flag as urgent request.</span>
                    </div>
                </div>
            </div>
            
            

            <div class="modal-errors">
                <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
            </div>

            <div class="form-line">
                <div class="form-field">
                    <div class="small-note">
                        <b>Warehouse Request</b> are the most convenient way for
                        you to contact the warehouse about specific order(s).<br /><br />

                        <b>Please note:</b> <i>Once any package has left the warehouse and it is
                        with the carrier, we can’t do any changes to the package and its
                        best to contact the carrier directly.</i>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="response.data" class="large-form">
            <p>Your warehouse request has been sent successfully. <br>We will be in touch soon.</p>
        </div>
        <div class="form-actions">
            <span v-if="!response.data" class="ws-button ws-button-main" data-action="cancel" @click="submitRequestModal">SEND WAREHOUSE REQUEST</span>
            <span class="ws-button ws-button-secondary" data-action="cancel" @click="closeRequestModal">GO BACK</span>
        </div>
    </modal>
</template>

<script>
import Modal from "@/components/modals/Modal.vue";

export default {
    name: "WarehouseRequestModal",
    components: {Modal},
    props: ['type','items'],
    data() {
        return {
            form: {type: null, items: [], subject: 'General Query', message: '', urgent: false},
            errors: {},
            response: {data: null}
        }
    }, 
    created() {
        this.form.type = this.type;
        const pluck = (arr, key) => arr.map(i => i[key]);
        this.form.items = pluck(this.items, 'id');
    },
    methods: {
        async submitRequestModal() {
            let fieldsToValidate = [
                { name: 'Subject', value: this.form.subject, rules: ['required'] },
                { name: 'Message', value: this.form.message, rules: ['required'] },
            ];
            this.errors = this.validateFields(fieldsToValidate);
            if (Object.keys(this.errors).length) return;

            this.response = await this.dispatchWaitAndNotify('createWarehouseRequest', this.form);

            if (this.response.data) {
                this.form.type = null;
                this.form.items = [];
                this.form.subject= 'General Query';
                this.form.message = '';
                this.form.urgent = false;
            }
            this.$emit('sent');
        },
        closeRequestModal() {
            this.modals.whRequestModal = false;
        },
    },
    computed: {
        user() {
            return this.$store.state.currentUser;
        },
        modals() {
            return this.$store.state.modals;
        },
    },
}
</script>

<style scoped>
.field-product .product-image {
    float: left;
    display: inline-block;
    margin-right: 15px;
    width: 64px;
    height: 59px;
    border-radius: 5px;
    background-size: cover;
    background-color: #eee;
    background-repeat: no-repeat;
    background-position: center;
}

.field-product .product-name {
    font-size: 15px;
    padding-top: 8px;
}

.field-product .product-sku {
    font-size: 12px;
}
</style>